import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStore = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.6667 7A1.6667 1.6667 0 0 0 5 7A1.6667 1.6667 0 0 0 8.3333 7A1.6667 1.6667 0 0 0 11.6667 7A1.6667 1.6667 0 0 0 15 7A1.6667 1.6667 0 0 0 18.3333 7L18.3333 3.3333A1 1 0 0 0 17.3333 2.3333L2.6667 2.3333A1 1 0 0 0 1.6667 3.3333ZM3 8.6667L3 16.3333A1.3333 1.3333 0 0 0 4.3333 17.6667L15.6667 17.6667A1.3333 1.3333 0 0 0 17 16.3333L17 8.6667M3 14L17 14",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgStore;
